import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

const GITCHA_PRO_URL = baseURL + "api/v2/gitcha-pro";

export async function getGitchaProOffer() {
  return await apiService.apiCall(`${GITCHA_PRO_URL}/offer`, "GET", {});
}

export async function startGitchaProTrial(paymentModeId) {
  return await apiService.apiCall(`${GITCHA_PRO_URL}/trial`, "POST", {
    PaymentModeId: paymentModeId,
  });
}

export async function keepGitchaPro(paymentModeId) {
  return await apiService.apiCall(`${GITCHA_PRO_URL}/keep`, "POST", {
    PaymentModeId: paymentModeId,
  });
}
